import { CollectionData } from "../models/CollectionData";
import { Response } from "../../../../shared/models/Response";
import axios from "axios";
import { DashboardFilter } from "../models/DashboardFilter";
import { ChartData } from "../models/ChartData";
import { ActionParameters } from "../models/ActionParameters";
import { ActionTask, ActionTaskResponse } from "../models/ActionTask";
import { TableHeader } from "../models/TableHeader";

export class DashboardService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/dashboard`;
  }

  async getCollectionFilter(
    query: DashboardFilter
  ): Promise<Response<CollectionData>> {
    const response = await axios.get(`${this.baseUrl}/collection-filter`, {
      params: query
    });
    return response.data;
  }

  async getCollectionFilterData(
    query: DashboardFilter
  ): Promise<Response<CollectionData>> {
    const response = await axios.get(`${this.baseUrl}/collection-filter/data`, {
      params: query
    });
    return response.data;
  }

  async getExtraCollectionData(body: {
    collection: string;
    ids: string[];
  }): Promise<Response<ChartData[] | void>> {
    const response = await axios.post(
      `${this.baseUrl}/collection-data-by-array`,
      body
    );
    return response.data;
  }

  async applyUserActions(
    newAction: ActionParameters
  ): Promise<Response<ActionTaskResponse | void | any>> {
    const response = await axios.post(
      `${this.baseUrl}/execute-action`,
      newAction
    );
    return response.data;
  }

  async applyTaskActions(
    action: ActionTask
  ): Promise<Response<ActionTaskResponse | void>> {
    const serviceUrl = `${this.baseUrl}/apply-task-actions`;
    const response = await axios.put(serviceUrl, action);
    return response.data;
  }

  async getExcelGeneratedFile(query: DashboardFilter, headers: TableHeader[]) {
    const response = await axios.post(`${this.baseUrl}/complete-report`, {
      parameters: query,
      headers: headers
    });
    return response.data;
  }

  async updateOrdersStatus(
    state?: string,
    query?: DashboardFilter,
    orderIds?: string[]
  ) {
    const response = await axios.post(`${this.baseUrl}/update-order-status`, {
      parameters: query,
      orderIds: orderIds,
      state: state
    });
    return response.data;
  }

  async updateServiceStatus(
    state?: string,
    query?: DashboardFilter,
    servicesIds?: string[]
  ) {
    const response = await axios.post(`${this.baseUrl}/update-service-status`, {
      parameters: query,
      servicesIds,
      state: state
    });
    return response.data;
  }
}
